// extracted by mini-css-extract-plugin
export default {"menuItem":"styles_menuItem__HvUHo"};